import { BookingTypeBadge } from '@Components/StorageStock/BookingTypeBadge';
import { type ApiStorageTransaction, getStorageTransactionSourceLabel } from '@Model';
import {
    Button,
    FlexColumn,
    FlexRow,
    iconSizeSm,
    renderDateTime,
    renderDecimal,
} from '@synqo/frontend-component-library';
import { IconX } from '@tabler/icons-react';
import classes from './BookingHeader.module.css';

interface IProps {
    booking: ApiStorageTransaction;
    onClose?: () => void;
}

/** The type tag, material and weight of a stored booking, when it was entered and where it comes from, and the close button. */
// @ai-generated 2026-10-27T10:00:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function BookingHeader({ booking, onClose }: IProps) {
    return (
        <FlexRow className={classes.header} justify="space-between" align="flex-start" gap="md">
            <FlexColumn gap="xxs" align="flex-start">
                <FlexRow align="center" gap="sm">
                    <BookingTypeBadge type={booking.type} />
                    <FlexRow className={classes.title}>
                        {`${booking.material.display_string} · ${renderDecimal(booking.quantity, 3)} t`}
                    </FlexRow>
                </FlexRow>
                <FlexRow
                    className={classes.subtitle}
                >{`${getStorageTransactionSourceLabel(booking)} · erfasst am ${renderDateTime(booking.created_at, 'datetime')}`}</FlexRow>
            </FlexColumn>
            {onClose && (
                <Button label="Schließen" onClick={onClose} appearance="transparent">
                    <IconX size={iconSizeSm} />
                </Button>
            )}
        </FlexRow>
    );
}
